






















































































import { Component, Prop } from 'vue-property-decorator';
import _trim from 'lodash/trim';
import { SwExtendedVue } from '../sw-extended-vue';
import { CSSStyleOptions } from '../common-types';

@Component({
  components: {
  },
})
export default class SwAvatar extends SwExtendedVue {
  @Prop({ type: String, required: true })
  name: string;

  @Prop(String)
  image: string;

  @Prop({ type: Boolean, default: false })
  clickable: boolean;

  @Prop({ type: Boolean, default: false })
  selected: boolean;

  get initials(): string {
    const words = _trim(this.name)
      .split(/\s+/);
    if (words.length > 1) {
      return `${words[0].charAt(0)}${words[1].charAt(0)}`;
    }
    return words[0].substr(0, 2);
  }

  get useImage(): boolean {
    return !!this.image;
  }

  get rootStyle(): CSSStyleOptions {
    const style: CSSStyleOptions = {};
    if (this.useImage) {
      style.backgroundImage = `url('${this.image}')`;
    }
    return style;
  }
}
